import React, { Component } from 'react';
import { Button, message, Modal, Table } from 'antd';
import moment from 'moment';

import { queryFileList, querySaveAttachment } from '@api/pub/attachment';
import baseData from '@util/base';
import util from '@util/index';
import ModalFile from '../custom/base/ModalFile';

class ModalFileList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
      },
      selectedRowKeys: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.customUuid = this.props.customUuid;
    this.choosedFiles = [];
    this.getFileList();
    this.getInitselectedRowKeys();
  }

  getInitselectedRowKeys = () => {
    const selectedRowKeys = [];
    this.props.selectedRows.forEach(item => selectedRowKeys.push(item.uuid));
    this.setState({
      selectedRowKeys,
    });
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.customUuid !== this.props.customUuid) {
      this.customUuid = nextProps.customUuid;
      this.getFileList();
    }
  }

  getFileList = () => {
    const current = this.current || 1;
    const pageSize = 5;
    queryFileList({
      itemUuid: this.customUuid,
      ...this.sorter,
      limit: pageSize,
      start: current,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: util.formatTableData(res.data, 'type'),
            pagination: {
              current: current || 1,
              total: res.totalSize,
              pageSize,
            },
          },
        });
      }
    });
  };

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys });
    const current = this.current || 1;
    this.choosedFiles = this.choosedFiles || {};
    this.choosedFiles[current] = selectedRows;
  };

  submit = params => {
    querySaveAttachment({
      ...params,
      itemUuid: this.customUuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.getFileList();
        this.handleVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  getType = type => {
    const index = baseData.attachmentType.findIndex(item => +item.key === +type);
    return index > -1 ? baseData.attachmentType[index].name : '';
  };

  handleVisible = (flag, fileParams) => {
    this.fileData = {};
    if (fileParams) {
      this.fileData = {
        type: fileParams.type,
        files: [
          {
            uuid: fileParams.uuid,
            name: fileParams.name,
            url: fileParams.url,
          },
        ],
      };
    }
    this.setState({
      visible: !!flag,
    });
  };

  columns = () => {
    return [
      {
        title: '文件类型',
        dataIndex: 'type',
        key: 'type',
        width: 150,
        sorter: true,
        render: (text, record) => {
          return <span>{this.getType(text)}</span>;
        },
      },
      {
        title: '源文件',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        render: (text, record) => (
          <a
            href={record.url}
            target="_blank"
            rel="noreferrer"
            style={{
              wordWrap: 'break-word',
              wordBreak: 'normal',
              display: 'block',
              width: '150px',
            }}
          >
            {text}
          </a>
        ),
      },
      {
        title: '添加时间',
        dataIndex: 'createDate',
        sorter: true,
        width: 150,
        render: (text, record) => {
          return moment.unix(text / 1000).format('YYYY-MM-DD');
        },
      },
      {
        title: '添加人',
        width: 150,
        dataIndex: 'createName',
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return <a onClick={() => this.handleVisible(true, record)}>编辑</a>;
        },
      },
    ];
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    if (sorter) {
      this.sorter = {
        sorts: `${sorter.field === 'type' ? 'pubatmType' : 'pubatmCdate'},${
          sorter.order ? sorter.order.replace('end', '') : 'desc'
        }`,
      };
    }
    this.getFileList();
  };

  formatFiles = params => {
    const { selectedRowKeys } = this.state;
    const { selectedRows = [] } = this.props;
    // 保存已选的文件，可能存在待翻页的数据
    let files = selectedRows;
    const fileUuids = [];
    params.forEach(item => {
      const fileItem = item || [];
      files = files.concat(fileItem);
    });
    // 去除取消选择的文件
    files = files.filter(item => selectedRowKeys.indexOf(item.uuid) > -1);
    // 文件去重
    files = files.filter(item => {
      if (fileUuids.indexOf(item.uuid) < 0) {
        fileUuids.push(item.uuid);
        return item;
      }
      return false;
    });
    return files;
  };

  handleOk = () => {
    const files = this.formatFiles(this.choosedFiles);
    this.props.handleChooseFile(files);
    this.props.handleCancel(false);
  };

  render() {
    const { customUuid, fileVisible, handleCancel } = this.props;
    const {
      loading,
      visible,
      dataSource: { list, pagination },
      selectedRowKeys,
    } = this.state;
    const extra = (
      <Button onClick={this.handleVisible} style={{ marginBottom: '16px' }}>
        上传附件
      </Button>
    );
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    return (
      <Modal
        title="附件信息"
        visible={fileVisible}
        onCancel={() => handleCancel(false)}
        width={800}
        onOk={this.handleOk}
      >
        {extra}
        <Table
          bordered
          columns={this.columns()}
          dataSource={list}
          pagination={pagination}
          rowKey="uuid"
          onChange={this.handleTableChange}
          loading={loading}
          rowSelection={rowSelection}
        />
        <ModalFile
          customUuid={customUuid}
          visible={visible}
          handleCancel={this.handleVisible}
          handleOk={this.submit}
          fileData={this.fileData}
        />
      </Modal>
    );
  }
}

export default ModalFileList;



// WEBPACK FOOTER //
// ./src/components/incubator/comm/ModalFileList.js